import addduty from './src/addduty.vue'  //监控设备管理


let views = {
    addduty
};

export default views;